// extracted by mini-css-extract-plugin
module.exports = {"lockedIcon":"SectionLockedStyles_lockedIcon__1v8kg"};